/**
 * TW PDP Rating — scroll to Yotpo reviews widget on star-rating click.
 */
(function () {
  const HEADER_BUFFER = 16;
  const FALLBACK_HEADER_OFFSET = 80;
  const YOTPO_WIDGET_SELECTORS = [
    '.yotpo-main-widget',
    '#yotpo-reviews-main-widget',
    '.yotpo-reviews-main-widget',
  ].join(', ');

  function getHeaderOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const parsed = parseFloat(raw);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed + HEADER_BUFFER;
    }
    return FALLBACK_HEADER_OFFSET;
  }

  function isVisible(el) {
    if (!el) return false;
    const section = el.closest('.shopify-section');
    if (section && section.offsetParent === null) return false;
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  function findReviewsTarget() {
    for (const anchor of document.querySelectorAll('[data-tw-reviews-target]')) {
      if (!isVisible(anchor)) continue;
      return anchor.closest('.shopify-section') || anchor;
    }

    const mainProduct = document.querySelector('[id^="MainProduct-"], product-info');
    for (const widget of document.querySelectorAll(YOTPO_WIDGET_SELECTORS)) {
      const section = widget.closest('.shopify-section');
      if (!section) continue;
      if (mainProduct && mainProduct.contains(section)) continue;
      if (!isVisible(section)) continue;
      return section;
    }

    return null;
  }

  function scrollToReviews(target) {
    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function scrollToReviewsWithRetry(attempt) {
    const target = findReviewsTarget();
    if (target) {
      scrollToReviews(target);
      if (history.replaceState) {
        history.replaceState(null, '', '#reviews');
      } else {
        window.location.hash = 'reviews';
      }
      return true;
    }

    if (attempt < 2) {
      const delay = attempt === 0 ? 300 : 800;
      setTimeout(() => scrollToReviewsWithRetry(attempt + 1), delay);
    }

    return false;
  }

  function onClick(event) {
    const trigger = event.target.closest('[data-tw-scroll-to-reviews]');
    if (!trigger) return;

    event.preventDefault();
    scrollToReviewsWithRetry(0);
  }

  document.addEventListener('click', onClick);
})();
